import { render, staticRenderFns } from "./pro-details.vue?vue&type=template&id=d4e0c176&scoped=true&"
import script from "./pro-details.vue?vue&type=script&lang=js&"
export * from "./pro-details.vue?vue&type=script&lang=js&"
import style0 from "./pro-details.vue?vue&type=style&index=0&id=d4e0c176&scoped=true&lang=scss&"
import style1 from "./pro-details.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4e0c176",
  null
  
)

export default component.exports